import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { blue, grey, portexColor, red } from "../theme/color";

const SPACE = 24;

const sharedStyles = ({ palette }: Theme) =>
  createStyles({
    listBox: {
      margin: "4px 0",
      padding: 0,
      zIndex: 1,
      top: 8,
      left: 0,
      right: 0,
      listStyle: "none",
      backgroundColor: palette.background.paper,
      overflow: "auto",
      maxHeight: "40vh",
      border: "1px solid",
      borderColor: palette.grey["200"],
      borderRadius: 4,
    },
    option: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      cursor: "pointer",
      paddingTop: 6,
      boxSizing: "border-box",
      outline: "0",
      WebkitTapHighlightColor: "transparent",
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16,
      "& svg": {
        marginLeft: -4,
        marginRight: 8,
      },
      '&[aria-selected="true"]': {
        backgroundColor: blue["100"],
        fontWeight: "bold",
        color: blue["500"],
        "& *": {
          color: blue["300"],
        },
      },
      '&[data-focus="true"]:not([aria-selected="true"])': {
        backgroundColor: palette.action.hover,
      },
      "&:active": {
        fontWeight: "bold",
      },
      '&[aria-disabled="true"]': {
        opacity: palette.action.disabledOpacity,
        pointerEvents: "none",
      },
    },
    groupLabel: {
      fontSize: "0.75rem",
      fontWeight: "bold",
      textTransform: "uppercase",
      color: palette.grey["500"],
      lineHeight: "2.5rem",
      backgroundColor: palette.background.paper,
      letterSpacing: "0.5px",
    },
    groupUl: {
      padding: 0,
    },
    popper: {
      zIndex: 1400,
    },
    clear: {
      margin: "-0.5rem -0.5rem -0.5rem 0",
      "& svg": {
        color: grey[400],
      },
    },
  });
export const useComboBoxStyles = makeStyles(
  ({ palette, ...rest }) => ({
    anchor: {
      position: "relative",
      boxShadow: `inset 0 0 0 1px ${palette.grey["500"]}`,
      borderRadius: 4,
      backgroundColor: "#fff",
      padding: "0.625rem 0",
    },
    comboBox: {
      padding: "0 1rem",
      position: "relative",
      display: "flex",
      "& + $comboBox, & + $addMore": {
        marginTop: SPACE,
        "&:after": {
          content: '""',
          display: "block",
          height: SPACE,
          border: "1px dashed",
          borderColor: palette.grey["500"],
          position: "absolute",
          left: `calc(1rem + 3px)`,
          top: 0,
          transform: "translateY(-100%)",
        },
      },
      "&:first-of-type": {
        "& $dot": {
          borderRadius: "50%",
        },
      },
    },
    addMore: {
      padding: "0 1rem",
      display: "flex",
      alignItems: "center",
      width: "100%",
    },
    addMorePalette: (props: any) => ({
      color: (portexColor as any)[`${props?.palette}500`] ?? "",
      "& [class*='-dot']": {
        backgroundColor: (portexColor as any)[`${props?.palette}500`] ?? "",
      },
    }),
    inputBase: {
      display: "flex",
    },
    input: {
      padding: 0,
      height: "auto",
      lineHeight: "1.25em",
    },
    dot: {
      width: 8,
      height: 8,
      backgroundColor: palette.grey["900"],
      marginRight: 12,
      flexShrink: 0,
    },
    dotCircular: {
      borderRadius: "50%",
    },
    ...sharedStyles({ palette, ...rest }),
  }),
  { name: "MuiComboBox" }
);

export const useComboBoxInputStyles = makeStyles(
  ({ palette, ...rest }) => ({
    anchor: {}, // dummy to make Type happy!
    dot: {}, // dummy to make Type happy!
    addMore: {}, // dummy to make Type happy!
    addMorePalette: {}, // dummy to make Type happy!
    dotCircular: {}, // dummy to make Type happy!
    comboBox: {
      position: "relative",
      display: "flex",
    },
    inputBase: {
      display: "flex",
      padding: "8px 0",
      borderRadius: 4,
      border: "1px solid",
      borderColor: palette.grey["300"],
      backgroundColor: palette.background.paper,
      "&:not(.Mui-focused):not(.Mui-error):not(.Mui-disabled):hover": {
        borderColor: palette.grey["500"],
      },
      "&.Mui-focused": {
        borderColor: palette.primary.main,
        boxShadow: `0 0 0 1px ${palette.primary.main}`,
      },
      "&.Mui-focused.MuiInputBase-colorSecondary": {
        borderColor: palette.secondary.main,
        boxShadow: `0 0 0 1px ${palette.secondary.main}`,
      },
      "&.Mui-error": {
        borderColor: palette.error.main,
        backgroundColor: red["100"],
        "&.Mui-focused": {
          boxShadow: `0 0 0 1px ${palette.error.main}`,
        },
      },
      "& svg": {
        margin: "0 6px",
      },
      "&.Mui-disabled": {
        backgroundColor: palette.grey["100"],
        "& svg": {
          color: palette.grey[500],
        },
      },
    },
    input: {
      padding: 0,
      height: "auto",
      lineHeight: "1.25em",
    },
    ...sharedStyles({ palette, ...rest }),
  }),
  { name: "MuiComboBoxInput" }
);
